/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".control[_ngcontent-%COMP%]{width:100%;background-color:#85cddb;color:#fff;padding:1rem}.control[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{background-color:transparent;border:0;color:#fff}div.item[_ngcontent-%COMP%]{background-color:grey}div.error[_ngcontent-%COMP%]{background-color:red}"];
export { styles as styles };
